import { IonButton, IonIcon } from "@ionic/react";
import { cartOutline } from "ionicons/icons";
import { useRef } from "react";
import { appSubDir } from "../../configs/app";

export let checkoutModalRef: React.RefObject<HTMLIonModalElement>;
export let cartModalRef: React.RefObject<HTMLIonModalElement>;

const CartModal: React.FC = () => {
    cartModalRef = useRef<HTMLIonModalElement>(null);
    checkoutModalRef = useRef<HTMLIonModalElement>(null);

    return (
        <IonButton fill='clear' id="btn-min-cart" routerLink={appSubDir + "cart"}>
            <IonIcon size='large' icon={cartOutline} />
        </IonButton>
    );
};

export default CartModal;
